<div class="marine-insurance-quote-view-data">
  <div class="row mb-1" *ngIf="isShowCertificateData">
    <div class="col-5 col-md-6 marine-insurance-quote-view-data-label">
      {{ "CERTIFICATE_NUMBER" | translate }}
    </div>
    <div class="col-7 col-md-6 marine-insurance-quote-view-data-value">
      {{ marineInsurance?.certificate?.number }}
    </div>
  </div>

  <div class="row mb-1">
    <div class="col-5 col-md-6 marine-insurance-quote-view-data-label">
      {{ "COMMODITIES_CATEGORY" | translate }}
    </div>
    <div class="col-7 col-md-6 marine-insurance-quote-view-data-value">
      {{
        isShowUpdatedInsuredValue ? marineInsurance?.updatedInsuredValue?.commodity?.name : marineInsurance?.insuredValue?.commodity?.name
      }}
    </div>
  </div>

  <div class="row mb-1" *ngIf="isVehiclesCommodity && !!manufactureDate">
    <div class="col-5 col-md-6 marine-insurance-quote-view-data-label">
      {{ "LABELS.MANUFACTURE_YEAR" | translate }}
    </div>
    <div class="col-7 col-md-6 marine-insurance-quote-view-data-value">
      {{ manufactureDate | customDateByUtc : "YYYY" }}
    </div>
  </div>

  <div class="row mb-1">
    <div class="col-5 col-md-6 marine-insurance-quote-view-data-label">
      {{ "INSURED_VALUE" | translate }}
    </div>
    <div class="col-7 col-md-6 marine-insurance-quote-view-data-value">
      {{
        (isShowUpdatedInsuredValue ? marineInsurance?.updatedInsuredValue?.insuredAmount : marineInsurance?.insuredValue?.insuredAmount)
          | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2"
      }}
    </div>
  </div>

  <div class="row mb-1" *ngIf="!!marineInsurance?.shippingDate && isShowDepartureDate">
    <div class="col-5 col-md-6 marine-insurance-quote-view-data-label">
      {{ "LABELS.DEPARTURE_DATE" | translate }}
    </div>
    <div class="col-7 col-md-6 marine-insurance-quote-view-data-value">
      {{
        (isShowUpdatedDate && !!marineInsurance?.updatedShippingDate ? marineInsurance?.updatedShippingDate : marineInsurance?.shippingDate)
          | customDateByUtc
      }}
    </div>
  </div>
</div>
